import React, { useState } from "react"
import styled from "@emotion/styled"
import { Link } from "gatsby"

import Hamburger from "./Hamburger"
import MobileMenu from "./MobileMenu"
import DesktopMenu from "./DesktopMenu"
import Userfy from "../../../images/userfy2.svg"

const Outer = styled.nav`
  width: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns:
    minmax(32px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(32px, auto);
  padding: 24px 0;
  z-index: 2;
  background-color: ${props =>
    props.isOpen ? props.theme.shade[90] : "#ffffff90"};
  position: fixed;
  backdrop-filter: ${props => (props.isOpen ? "none" : "blur(1rem)")};
  transition: 0.2s background-color, backdrop-filter;
`
const Inner = styled.div`
  grid-column: 2;
  position: relative;
  display: grid;
  grid-template-columns: 112px 1fr;
`
const Brand = styled.div`
  margin: auto;
  display: flex;
  align-items: center;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
`
const Logo = styled.img`
  width: 100%;
  height: 100%;
  margin: 0;
`

export default function Nav({ colorOverride }) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <MobileMenu isOpen={open} />
      <Outer isOpen={open}>
        <Inner>
          <Brand>
            <Link to="/">
              <Logo src={Userfy} alt="Userfy Logo" />
            </Link>
          </Brand>
          <Hamburger
            onClick={() => setOpen(!open)}
            isOpen={open}
            colorOverride={colorOverride}
          />
          <DesktopMenu isOpen={open} />
        </Inner>
      </Outer>
    </>
  )
}
